/**
 * Metadata slice (RTK). Uses metadataReducerLegacy for existing action types.
 * Same state shape as state.Metadata.
 */
import { createSlice } from "@reduxjs/toolkit";
import metadataReducerLegacy, {
  metadataInitialState,
} from "./metadataReducerLegacy";

const metadataSlice = createSlice({
  name: "metadata",
  initialState: metadataInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addDefaultCase(metadataReducerLegacy);
  },
});

export default metadataSlice.reducer;
